import { ReactComponent as Info } from '../Icons/Circle_info.svg';
import { ReactComponent as Warning } from '../Icons/Warning.svg';
import { ReactComponent as Success } from '../Icons/Circle_check.svg';
import ValidationStatus from './ValidationStatus';
import ColorScheme from '../ColorScheme/ColorScheme';

const Validation = ({ className = '', text, validationStatus = ValidationStatus.Info, showIcon = true }) => {
    const statusMap = {
        [ValidationStatus.Error]: {
            text: 'sf-negative-500',
            icon: <Info className="h-3 w-3 mr-1" fill={ColorScheme['sf-negative-300']} />
        },
        [ValidationStatus.Success]: {
            text: 'sf-positive-500',
            icon: <Success className="h-3 w-3 mr-1" fill={ColorScheme['sf-positive-300']} />
        },
        [ValidationStatus.Warning]: {
            text: 'sf-neutral-500',
            icon: <Warning className="h-3 w-3 mr-1" fill={ColorScheme['sf-neutral-300']} />
        },
        [ValidationStatus.Info]: {
            text: 'sf-gray-500',
            icon: <Info className="h-3 w-3 mr-1" fill={ColorScheme['sf-gray-300']} />
        }
    };

    return (
        <div className={`flex font-sf items-center h-3 text-10 font-normal ${className}`}>
            {showIcon && statusMap[validationStatus]?.icon}
            {<span className={`text-${statusMap[validationStatus]?.text}`}>{text}</span>}
        </div>
    );
};

export default Validation;
